import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Candidate } from '@app/models/offer-letters/candidate.model';

export class JobTitleColumn extends Column {
    title = 'table.offer-letter.jobTitle';
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(candidate: Candidate): string {
        return candidate.position ?? '-';
    }
}
